import axios from 'axios'

const api = axios.create({
  withCredentials: true,
})

// Handle 401 errors - redirect to login
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      if (window.location.pathname !== '/login') {
        console.warn('Unauthorized - redirecting to login')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export const getLogs = async (limit = 100, days = 90) => {
  const response = await api.get('/api/logs', {
    params: { limit, days }
  })
  return response.data
}

export default api
